import { BooleanQueryError, Node } from './types';

const isPositive = (node: Node): boolean => {
  switch (node.type) {
    case 'term':
      return true;
    case 'not':
      return false;
    case 'and':
      return node.children.some(isPositive);
    case 'or':
      return node.children.every(isPositive);
    default:
      return false;
  }
};

const walk = (node: Node): void => {
  if (node.type === 'and' || node.type === 'or') {
    if (!isPositive(node)) {
      throw new BooleanQueryError('pure_negative');
    }
    node.children.forEach(walk);
  }

  if (node.type === 'not') {
    walk(node.child);
  }
};

export const validate = (node: Node): void => {
  if (!isPositive(node)) {
    throw new BooleanQueryError('pure_negative');
  }
  walk(node);
};
